import React, {Component} from 'react';
import ListGroup from 'react-bootstrap/ListGroup'
import {Link} from "react-router-dom";

//cal rebre a través de props: resultats, municipis, codipartit



class PartitPobleMesVotat extends Component {
    
    generaTaulaMesVotats(){
        var taulaPobles = []

        this.props.municipis.map((municipi) => { //recorrem cada municipi
            var resultatsMunicipi;

            this.props.resultats.forEach(element => { //recorrem els resultats per trobar el del municipi
                if (element.dadesMunicipi.codi === municipi.codi_generalitat) resultatsMunicipi = element.resultatsCandidatures;
            });

            // console.log(resultatsMunicipi);
            if (resultatsMunicipi.length>0) {
                
                resultatsMunicipi.map((element) => {
                    if (element.codi === this.props.codiPartit) {
                        var elementAfegir = {nom:municipi.nom, slug:municipi.slug, percentatge:element.vots_per}
                        taulaPobles.push(elementAfegir);
                    } 
                })//recorrem els resultats buscant el partit
            }
        }
        );

        taulaPobles.sort(this.ordenaTaula);
        // console.log(taulaPobles);
        
        return taulaPobles;

    }

    generaTaula () {

    }

    ordenaTaula(a, b) {
        if (a.percentatge>b.percentatge) {
          return -1;
        }
        if (a.percentatge<b.percentatge) {
          return 1;
        }
        // a debe ser igual b
        return 0;
      }


    render() {     
        var taulaPobles=this.generaTaulaMesVotats();

     return (
       taulaPobles.length>0 && 
       <div>
            <ListGroup variant="flush">
                {taulaPobles.map((poble, index)=>(!this.props.limit||index<this.props.limit) && <ListGroup.Item className={"pobleLlista llistaPosicio"+(index+1)}><span className="posicio">{index+1}.</span>  <span className="nomPoble"><Link to={"/resultats/" + poble.slug}>{poble.nom}</Link></span> <span className="percentatge">{poble.percentatge.toFixed(2).toString().replace(/\./g, ',')} %</span></ListGroup.Item>)}
            </ListGroup>
        </div>   
      );
    }
  }

  export default PartitPobleMesVotat;